import { CustomBadgesTab } from './badges-custom-tab'
import { TrivieBadgesTab } from './badges-default-tab'

export const badgesTabs = [CustomBadgesTab, TrivieBadgesTab]
